import React from 'react';
import { v4 } from 'uuid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { blueGrey } from '@material-ui/core/colors';

import {
  onBlurSearch,
  onFocusSearch,
  onUpdateSearchTerm,
  onSearchKeyboardUp,
  onSearchKeyboardDown,
  onSearchKeyboardEnter,
} from '../../store/actions/search';
import Results from './Results';

import Icon from './Icon';

const Root = styled.div`
  width: 641px;
  height: 54px;
  display: flex;
  outline: none;
  margin-top: 8px;
  max-width: 700px;
  padding: 12px 32px;
  position: relative;
  flex-direction: row;
  align-items: center;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  &:hover {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.75);
  }
  @media (max-width: 1170px) {
    flex-basis: 100%;
  }
`;

const Input = styled.input`
  flex: 1;
  margin: 0;
  padding: 0;
  display: flex;
  outline: none;
  font-size: 18px;
  line-height: 21px;
  position: relative;
  flex-direction: row;
  align-items: center;
  color: ${blueGrey[800]};
  border: none !important;
  -webkit-appearance: none !important;
  &:placeholder {
    color: ${blueGrey[600]};
  }
`;

const PLACEHOLDER =
  'Find anything like Marketing Dashboard or 2044915806.man...';

function Bar({
  onUp,
  value,
  onBlur,
  onDown,
  onFocus,
  onEnter,
  onUpdate,
  className,
}) {
  function handleChange(e) {
    onUpdate({ term: e.target.value });
  }

  function handleKeyDown(e) {
    const actions = [
      ['ArrowUp', onUp],
      ['Enter', onEnter],
      ['ArrowDown', onDown],
    ];

    actions.forEach(([key, func]) => {
      if (key === e.key) {
        e.preventDefault();

        func();
      }
    });
  }

  return (
    <Root className={className}>
      <Icon />
      <Input
        autoFocus
        id="search"
        // This next line prevents
        // autocorrect. Input suggestions
        // may interfere with our search
        // results so we disable it.
        name={v4()}
        value={value}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={PLACEHOLDER}
      />
      <Results />
    </Root>
  );
}

Bar.propTypes = {
  className: PropTypes.string,
  onUp: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onDown: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onFocus: PropTypes.func.isRequired,
  onEnter: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

Bar.defaultProps = {
  className: '',
};

const mapStateToProps = ({ search: { term } }) => ({
  value: term,
});

const mapDispatchToProps = d => ({
  onBlur: () => d(onBlurSearch()),
  onFocus: () => d(onFocusSearch()),
  onUp: () => d(onSearchKeyboardUp()),
  onDown: () => d(onSearchKeyboardDown()),
  onEnter: () => d(onSearchKeyboardEnter()),
  onUpdate: ({ term }) => d(onUpdateSearchTerm({ term })),
});

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(Bar);

export default connected;
